import { render, staticRenderFns } from "./ContentCard.vue?vue&type=template&id=00389248&scoped=true"
import script from "./ContentCard.vue?vue&type=script&lang=js"
export * from "./ContentCard.vue?vue&type=script&lang=js"
import style0 from "./ContentCard.vue?vue&type=style&index=0&id=00389248&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00389248",
  null
  
)

export default component.exports